module.exports = __webpack_public_path__ + "resources\\localization\\en-us.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/en-us.json
 ** module id = 29
 ** module chunks = 0
 **/